
import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import {
  FaArrowLeft,
  FaArrowRight,
  FaChevronLeft,
  FaChevronRight,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaBuilding,
  FaMobileAlt,
  FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram,
  FaHardHat
} from 'react-icons/fa';
import { GiCrane } from "react-icons/gi";
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


const MyPage = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);
  return (
    <div className="min-h-screen flex flex-col">
      {/* Main Content */}
      <main className="flex-grow">
        <CustomSlider />
        <AboutSection />
        <ProjectCarousel />
        <OurServices />
        <StatsSection />
        <CEOScreen />
        <ProjectsSection />
        <ContactForm />
      </main>
    </div>
  );
};


const CustomSlider = () => {
  const slides = [
    {
      image: "/images/Picture53.jpg",
      content: "Variant Apartment Building at Plot No. 23/24, Gulberg III",
      description:
        "Civil works.",
    },

    {
      image: "/images/Picture35.jpg",
      content: "M.A. Jinnah Mosque Bahria Orchard-2, Lahore.",
      description:
        "Civil works.",
    },
    {
      image: "/images/Profile3.jpg",
      content: "Bahria Orchard-4 School, Lahore.",
      description:
        "Civil works.",
    },
    {
      image: "/images/Profile4.jpg",
      content: "Union Tower Sialkot",
      description:
        "Civil works.",
    },
    {
      image: "/images/Profile5.jpg",
      content: "Boulevard Heights, Lahore",
      description:
        "Civil and finishing works",
    },
    {
      image: "/images/Profile.jpg",
      content: "Dar-ul-Shifa Hospital",
      description:
        "Construction of a three story hospital including basement with finishes, electrical, mechanical and HVAC work.",
    },
    {
      image: "/images/Profile6.jpg",
      content: "Sitara Sapna City, Faisalabad",
      description:
        " Construction of 100 houses of 10 marla, 15 marla and 1 kanal.",
    },
    {
      image: "/images/Picture62.jpg",
      content: "Commercial Building 3-Tariq Block",
      description:
        "Structural, electrical, mechanical, finishing, elevators, etc.",
    },
    {
      image: "/images/Profile7.jpg",
      content: "City Center Multan",
      description:
        "Construction of a high rise mall, subcontract by United Engineers (Pvt) Ltd.",
    },
    {
      image: "/images/Profile8.jpg",
      content: "Residential villas",
      description:
        "Luxury Villa in DHA EME, Lahore.",
    },
    {
      image: "/images/Picture58.jpg",
      content: "Islamic Research Centre, Lahore",
      description:
        "Civil works.",
    }, {
      image: "/images/Picture74.jpg",
      content: "Five Star Textiles",
      description:
        "Steel construction with RCC foundation.",
    }, {
      image: "/images/Picture33.jpg",
      content: "Variant Apartment Building at Plot No. 29, Gulberg III",
      description:
        " Civil works.",
    }, {
      image: "/images/Picture76.jpg",
      content: "Masjid Al Hussain Bahria Town, Lahore.",
      description:
        "Civil works.",
    }, {
      image: "/images/Picture18.jpg",
      content: "Five Star Textiles",
      description:
        "Steel construction with RCC foundation.",
    },
    {
      image: "/images/mainaura.jpeg",
      content: "Aura Tower 3G Gulberg 2 Lahore",
      description:
        "Civil works.",
    }
  ];

  const [currentSlide, setCurrentSlide] = useState(0);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  useEffect(() => {
    const autoSlide = setInterval(() => {
      nextSlide();
    }, 3000);

    return () => clearInterval(autoSlide);
  }, [currentSlide]);

  return (
    <div className="relative w-full">
      {/* Slider Section */}
      <div className="relative w-full h-[70vh] sm:h-[80vh] lg:h-screen overflow-hidden">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`absolute w-full h-full transition-opacity duration-700 ease-in-out ${index === currentSlide ? "opacity-100" : "opacity-0"
              }`}
          >
            <img
              src={slide.image}
              alt={`Slide ${index + 1}`}
              className="w-full h-full"
            />
            <div className="absolute bottom-10 left-5 sm:left-10 text-white bg-black/60 p-4 rounded-lg max-w-md">
              <h3 className="text-lg sm:text-xl font-semibold mb-1">{slide.content}</h3>
              <p className="text-sm sm:text-base">{slide.description}</p>
            </div>
          </div>
        ))}

        {/* Navigation Arrows */}
        <button
          onClick={prevSlide}
          className="absolute left-2 sm:left-5 top-1/2 transform -translate-y-1/2 bg-gray-800/70 hover:bg-gray-800 text-white p-2 sm:p-3 rounded-full"
        >
          <FaArrowLeft />
        </button>
        <button
          onClick={nextSlide}
          className="absolute right-2 sm:right-5 top-1/2 transform -translate-y-1/2 bg-gray-800/70 hover:bg-gray-800 text-white p-2 sm:p-3 rounded-full"
        >
          <FaArrowRight />
        </button>
      </div>

      {/* Thumbnails */}
      <div className="flex justify-center flex-wrap gap-2 sm:gap-4 py-4 px-2 sm:px-4 bg-white">
        {slides.map((slide, index) => (
          <img
            key={index}
            src={slide.image}
            alt={`Thumbnail ${index + 1}`}
            className={`w-16 sm:w-20 h-10 sm:h-12 object-cover rounded-md cursor-pointer transition-all duration-300 ${index === currentSlide
              ? "border-2 border-teal-500 shadow-md"
              : "opacity-60 hover:opacity-100"
              }`}
            onClick={() => goToSlide(index)}
          />
        ))}
      </div>
    </div>
  );
};

const StatsSection = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 }); // Initialize AOS with a custom duration
  }, []);

  const useCountUp = (end) => {
    const [count, setCount] = useState(0);
    const ref = useRef();

    useEffect(() => {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            let start = 0;
            const duration = 2000;
            const stepTime = Math.abs(Math.floor(duration / end));
            const timer = setInterval(() => {
              start += 1;
              setCount(start);
              if (start === end) {
                clearInterval(timer);
              }
            }, stepTime);
            observer.disconnect();
          }
        },
        { threshold: 0.6 }
      );
      if (ref.current) observer.observe(ref.current);
    }, [end]);

    return [count, ref];
  };

  const [count1, ref1] = useCountUp(109);
  const [count2, ref2] = useCountUp(485);
  const [count3, ref3] = useCountUp(189);
  const [count4, ref4] = useCountUp(20);

  return (
    <div className="w-full overflow-hidden bg-gradient-to-b from-[#1BB095] to-teal-900 py-10 px-4 text-white mt-10 mb-10">
      <div className="max-w-7xl mx-auto grid grid-cols-2 md:grid-cols-2 gap-10">

        {/* Left Side */}
        <div className="grid grid-cols-2 gap-6 w-full">
          {/* Expert Workers */}
          <div
            className="flex flex-col items-center text-center"
            ref={ref1}
            data-aos="fade-up" // Added AOS animation for fade-up
          >
            <FaHardHat className="h-6 w-6 sm:h-8 sm:w-8 md:h-10 md:w-10 mb-2 sm:mb-3" />
            <h2 className="text-base sm:text-xl md:text-2xl font-bold">{count1}</h2>
            <p className="text-[10px] sm:text-sm font-medium mt-1">Expert Workers</p>
          </div>

          {/* Happy Clients */}
          <div
            className="flex flex-col items-center text-center"
            ref={ref2}
            data-aos="fade-up" // Added AOS animation for fade-up
          >
            <FaBuilding className="h-6 w-6 sm:h-8 sm:w-8 md:h-10 md:w-10 mb-2 sm:mb-3" />
            <h2 className="text-base sm:text-xl md:text-2xl font-bold">{count2}</h2>
            <p className="text-[10px] sm:text-sm font-medium mt-1">Happy Clients</p>
          </div>
        </div>

        {/* Right Side */}
        <div className="grid grid-cols-2 gap-6 w-full">
          {/* Completed Projects */}
          <div
            className="flex flex-col items-center text-center"
            ref={ref3}
            data-aos="fade-up" // Added AOS animation for fade-up
          >
            <FaMapMarkerAlt className="h-6 w-6 sm:h-8 sm:w-8 md:h-10 md:w-10 mb-2 sm:mb-3" />
            <h2 className="text-base sm:text-xl md:text-2xl font-bold">{count3}</h2>
            <p className="text-[10px] sm:text-sm font-medium mt-1">Completed Projects</p>
          </div>

          {/* Running Projects */}
          <div
            className="flex flex-col items-center text-center"
            ref={ref4}
            data-aos="fade-up" // Added AOS animation for fade-up
          >
            <GiCrane className="h-6 w-6 sm:h-8 sm:w-8 md:h-10 md:w-10 mb-2 sm:mb-3" />
            <h2 className="text-base sm:text-xl md:text-2xl font-bold">{count4}</h2>
            <p className="text-[10px] sm:text-sm font-medium mt-1">Running Projects</p>
          </div>
        </div>
      </div>
    </div>
  );
};

const AboutSection = () => {


  return (
    <div className="about mt-16 overflow-x-hidden">
      <div className="text-center mb-10" data-aos="fade-right">
        <h2 className="text-4xl font-bold text-teal-700">Company Profile</h2>
      </div>

      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center">
          {/* Left Image Section */}
          <div
            className="w-full md:w-1/2 lg:w-2/5 mb-8 md:mb-0"
            data-aos="fade-right"
          >
            <div className="about-img h-[300px] sm:h-[400px] md:h-[450px] lg:h-[500px] overflow-hidden rounded-lg shadow-lg">
              <img
                src="/images/Picture1.jpg"
                alt="Pacific Builders Project"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Right Text Section */}
          <div
            className="w-full md:w-1/2 lg:w-[60%] md:pl-8"
            data-aos="fade-left"
          >
            <div className="section-header text-left mb-4">
              <p className="text-teal-600 font-medium">Welcome to PACIFIC BUILDERS (PVT) LTD</p>
              <h2 className="text-2xl md:text-3xl font-bold">
                21 Years of Experience
              </h2>
            </div>

            <div className="about-text space-y-4 text-gray-700">
              {/* --- OVERVIEW Section --- */}
              <div className="pt-2 border-t border-gray-300">
                <h3 className="text-xl font-semibold text-teal-700 mb-2">Overview</h3>
                <p>
                  From concept to completion, Pacific Builders is a full-service management group offering design, general contracting,
                  construction management and execution of all types of Civil, Mechanical and Electrical projects.
                </p>
                <p>
                  Founded in 2005, Pacific Builders has demonstrated steady growth by delivering turnkey projects in commercial, residential,
                  and health sectors. With over 40 years of combined team experience, we have built a strong reputation for quality and speed.
                </p>
                <p>
                  Our evolving portfolio and increased project count has strengthened our profile over the years. While most of our projects
                  are turnkey contracts, we also collaborate with other companies as subcontractors.
                </p>

                <h4 className="text-lg font-semibold mt-4 text-teal-700">Fields of Expertise:</h4>
                <ul className="list-disc list-inside pl-4 space-y-1">
                  <li>High-rise, multi-storied buildings</li>
                  <li>Fabrication and installation of steel structures</li>
                  <li>Underground utilities</li>
                  <li>Industrial and commercial projects</li>
                  <li>Water supply and drainage projects</li>
                  <li>Residential complexes</li>
                  <li>Mosques</li>
                </ul>
              </div>

              {/* Optional Learn More button */}
              {/* <button className="inline-block mt-6 bg-gradient-to-r from-teal-600 to-teal-800 hover:from-teal-700 hover:to-teal-900 text-white px-6 py-3 rounded transition">
                Learn More
              </button> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const ProjectCarousel = () => {
  const projects = [
    {
      name: 'Commercial Building 3-Tariq Block.',
      image: '/images/Picture62.jpg',
      address: 'Garden Town, Lahore',
      details: 'Covered Area: 2 kanal | 1 basement 8 floors | Status: Complete. ',
      link: '/tariq-block',
    },
    {
      name: 'Bahria Orchard-4 School, Lahore.',
      image: '/images/Profile3.jpg',
      address: 'Lahore',
      details: 'Architect: Design wing, Bahria Town | Client: Bahria Town (PVT) LTD.| Status: Complete.',
      link: '/boahria-orchard',
    },
    {
      name: 'M.A. Jinnah Mosque Bahria Orchard-2, Lahore.',
      image: '/images/Picture35.jpg',
      address: 'Lahore',
      details: 'Architect: Design wing, Bahria Town | Client: Bahria Town (PVT) LTD.| Status: Ongoing',
      link: '/m.a-jinnah-mosque',
    },
    {
      name: 'Islamic Research Centre, Lahore',
      image: '/images/Picture58.jpg',
      address: 'Lahore',
      details: 'Architect: Nayyer Ali Dada | Covered Area: 80,000 sq ft| Client: Anjuman-e-Mohammadi | Status: Complete',
      link: '/islamic-research-centre',
    },
    {
      name: 'Union Tower Sialkot',
      image: '/images/Profile4.jpg',
      address: 'Sialkot',
      details: 'Covered Area: 175000 sq ft | Status: Ongoing',
      link: '/uniont-tower',
    },
    {
      name: 'Boulevard Heights, Lahore',
      image: '/images/Picture40.jpg',
      address: 'Lahore',
      details: 'Covered Area: 650,000 sq ft | 21-floor high rise commercial building | Client: HK Group | Status: Complete',
      link: '/boulevard-heights',
    },
    {
      name: 'Sitara Sapna City, Faisalabad',
      image: '/images/Profile6.jpg',
      address: 'Faisalabad',
      details: 'Covered Area: 450,000 sq ft | Client: Sitara Hamza (Private) Limited | Status: Complete',
      link: '/sitara-sapna',
    },
    {
      name: 'City Center Multan',
      image: '/images/Profile7.jpg',
      address: 'Multan',
      details: 'Covered Area: 340,000 sq ft  | Client: Dr. Tariq Khokar, IG  | Status: Complete',
      link: '/city-center',
    },
    {
      name: 'Residential villas',
      image: '/images/Profile8.jpg',
      address: 'Lahore',
      details: 'Luxury Villa in DHA EME, Lahore.',
      link: '/residential-villas',
    },
    {
      name: 'Dar-ul-Shifa Hospital',
      image: '/images/Profile.jpg',
      address: 'Faisalabad',
      details: 'Covered Area: 50,000 sq ft | Client: Dar ul Shifa Trust, Shifa International, Islamabad | Status: Complete',
      link: '/dar-ul-shifa',
    },
  ];

  const NextArrow = ({ onClick }) => (
    <div
      className="absolute right-2 top-1/2 transform -translate-y-1/2 z-10 bg-gray-700 hover:bg-gray-800 text-white p-2 rounded-full cursor-pointer shadow-md"
      onClick={onClick}
    >
      <FaChevronRight />
    </div>
  );

  const PrevArrow = ({ onClick }) => (
    <div
      className="absolute left-2 top-1/2 transform -translate-y-1/2 z-10 bg-gray-700 hover:bg-gray-800 text-white p-2 rounded-full cursor-pointer shadow-md"
      onClick={onClick}
    >
      <FaChevronLeft />
    </div>
  );

  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3500,
    speed: 800,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className="w-full max-w-5xl mx-auto px-4 py-12 ">
      {/* <div className="text-center mb-10">
        <h2 className="text-4xl font-bold text-teal-700">Our Services</h2>
        <p className="text-lg text-gray-600 mt-2">We Provide Services</p>
      </div> */}

      <div className="max-w-7xl mx-auto relative" data-aos="fade-up">
        <Slider {...settings}>
          {projects.map((project, index) => (
            <div key={index} className="px-3" >
              <Link to={project.link}>
                <div className="bg-white rounded-lg shadow-md h-[430px] overflow-hidden hover:shadow-xl transition-shadow duration-300">
                  <img
                    src={project.image}
                    alt={project.name}
                    className="w-full h-60"
                  />
                  <div className="p-4 flex flex-col justify-between h-[170px]">
                    <div>
                      <h3 className="text-lg font-bold text-gray-800">{project.name}</h3>
                      <p className="text-sm text-gray-600">{project.address}</p>
                    </div>
                    <p className="text-sm text-gray-600 mt-2">{project.details}</p>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

const OurServices = () => {
  const slides = [
    {
      img: '/images/Picture63.jpg',
      subtitle: 'We Build Luxury',
      title: 'Elegant Villas with Modern Architecture',
    },
    {
      img: '/images/Picture64.jpg',
      subtitle: 'Sky-High Excellence',
      title: 'High-Rise Buildings Crafted to Perfection',
    },
    {
      img: '/images/Picture65.jpg',
      subtitle: 'Trusted Construction Partner',
      title: 'Your Vision, Our Commitment to Build',
    },
  ];

  const skills = [
    {
      title: 'Project Management',
      description:
        'From timelines to resources, our experienced managers ensure smooth, on-time project execution with strict quality control.',
      img: '/images/c-skill2.jpg',
    },
    {
      title: 'Civil & Structural Works',
      description:
        'We specialize in civil infrastructure, foundations, and structural excellence for long-lasting construction.',
      img: '/images/c-skill3.jpg',
    },
    {
      title: 'Mechanical & Electrical Expertise',
      description:
        'Integration of modern MEP systems is our strong suit — efficient, safe, and future-ready installations.',
      img: '/images/c-skill4.jpg',
    },
  ];

  const [current, setCurrent] = useState(0);

  useEffect(() => {
    AOS.init({ duration: 1000, once: false });
  }, []);

  useEffect(() => {
    AOS.refresh();
  }, [current]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const prevSlide = () => {
    setCurrent((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
  };

  const nextSlide = () => {
    setCurrent((prev) => (prev + 1) % slides.length);
  };

  return (
    <>
      <div className="w-full py-16 text-gray-800">
        {/* Section Heading */}
        <div className="w-[90%] mx-auto" data-aos="fade-right">
          <h2 className="text-4xl font-bold text-center text-teal-700 mb-4">
            Our Services
          </h2>
          <p className="text-center text-lg mb-12">
            We bring a unique set of capabilities to every construction project.
          </p>
        </div>

        {/* Hero Slider */}
        <div className="relative w-full h-[90vh] overflow-hidden">
          {slides.map((slide, index) => (
            <div
              key={index}
              className={`absolute inset-0 transition-opacity duration-1000 ${index === current ? 'opacity-100 z-10' : 'opacity-0 z-0'
                }`}
            >
              <img
                src={slide.img}
                alt={`Slide ${index + 1}`}
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-black bg-opacity-50 flex flex-col items-center justify-center text-center text-white px-4">
                <p
                  key={`subtitle-${current}`}
                  data-aos="fade-right"
                  className="text-xl sm:text-2xl md:text-3xl font-light mb-2"
                >
                  {slide.subtitle}
                </p>
                <h1
                  key={`title-${current}`}
                  data-aos="fade-up"
                  className="text-3xl sm:text-5xl md:text-6xl font-bold"
                >
                  {slide.title}
                </h1>
              </div>
            </div>
          ))}

          {/* Slider Controls */}
          <button
            onClick={prevSlide}
            className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-black/50 text-white p-2 rounded-full hover:bg-black/70 z-20"
          >
            ‹
          </button>
          <button
            onClick={nextSlide}
            className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-black/50 text-white p-2 rounded-full hover:bg-black/70 z-20"
          >
            ›
          </button>

          {/* Slider Dots */}
          <div className="absolute bottom-5 left-1/2 transform -translate-x-1/2 flex gap-2 z-20">
            {slides.map((_, idx) => (
              <button
                key={idx}
                onClick={() => setCurrent(idx)}
                className={`w-3 h-3 rounded-full ${current === idx ? 'bg-white' : 'bg-white/50'
                  }`}
              ></button>
            ))}
          </div>
        </div>

        {/* Skills / Service Cards */}
        <div
          className="w-[90%] mx-auto grid sm:grid-cols-2 lg:grid-cols-3 gap-8 mt-10"
          data-aos="zoom-in-down"
        >
          {skills.map((skill, index) => (
            <div
              key={index}
              className="bg-white shadow-md rounded-lg overflow-hidden hover:shadow-lg transition-all duration-300"
            >
              <img
                src={skill.img}
                alt={skill.title}
                className="w-full h-40 object-cover"
              />
              <div className="p-4">
                <h3 className="text-xl font-semibold mb-2">{skill.title}</h3>
                <p className="text-gray-600 text-sm">{skill.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* More Details Button */}
        <div className="text-center mt-12" data-aos="fade-up">
          <Link
            to="/our-services"
            className="inline-block bg-teal-700 hover:bg-teal-800 text-white font-semibold px-6 py-3 rounded-full transition duration-300"
          >
            More Details
          </Link>
        </div>
      </div>
    </>
  );
};


const CEOScreen = () => {
  return (
    <div className="w-full  bg-black text-gray-800 flex flex-col lg:flex-row overflow-hidden mx-auto">
      {/* Left Section - Text */}
      <div className="lg:w-1/2 p-8 space-y-6" data-aos="zoom-in">
        <div data-aos="flip-left">
          <h2 className="text-2xl font-semibold text-teal-500">CEO Message</h2>
          <div className="w-5 h-1 bg-teal-500 mt-2" />
        </div>
        <p className="text-gray-400 leading-relaxed">
          Growing companies keep their past in mind and aspire to achieve unprecedented milestones in their future. We at Pacific Builders work on the same principles of ethics that were the root of our establishment. Since our beginnings, we are committed to providing personal and professional services in a responsive, high-quality manner. And we still abide by these core values.
        </p>
        <button className="border border-teal-600 text-teal-600 hover:bg-teal-600 hover:text-white font-semibold px-6 py-2 transition-all duration-300">
          MORE READING
        </button>
      </div>

      {/* Right Section - Image */}
      <div className="lg:w-1/2 relative min-h-[400px] sm:min-h-[400px] lg:min-h-[450px]">
        <img
          src="/images/Profile5.jpg"
          alt="CEO Building"
          className="absolute inset-0 w-full h-full object-cover"
        />

        {/* Bottom Section */}
        <div className="absolute bottom-0 left-0 w-full flex flex-col lg:flex-row">
          <div className="bg-gradient-to-b from-[#1BB095] to-teal-900 text-white p-4 flex-1">
            <p className="font-semibold">Call For a Quote:</p>
            <p>+92 42-35782365</p>
          </div>
          <button className="bg-white text-teal-700 hover:bg-teal-50 font-semibold px-6 py-4 border-t lg:border-l lg:border-t-0 border-teal-600">
            CONTACT US
          </button>
        </div>
      </div>
    </div>

  );
};

const ProjectsSection = () => {
  return (
    <section className="py-16 bg-white text-center">
      <div className="mb-12" data-aos="fade-right">
        <h2 className="text-4xl font-bold text-teal-700">Our Projects</h2>
        <p className="text-lg text-gray-600 mt-2">Completed & Ongoing Projects Overview</p>
      </div>

      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12">
        {/* Completed Projects */}
        <div>
          <img
            src="/images/Profile5.jpg"
            alt="Completed Projects"
            className="w-full h-80 object-cover rounded-lg shadow-lg"
          />
          <Link to="/all-projects">
            <button className="mt-6 bg-gradient-to-r from-teal-600 to-teal-800 text-white font-semibold py-3 px-6 rounded transition" data-aos="fade-up" data-aos-anchor-placement="bottom-bottom">
              Completed Projects →
            </button>
          </Link>
        </div>

        {/* Projects in Hand */}
        <div>
          <img
            src="/images/Profile4.jpg"
            alt="Projects in Hand"
            className="w-full h-80 object-cover rounded-lg shadow-lg"
          />
          <Link to="/all-projects" >
            <button className="mt-6 bg-gradient-to-r from-teal-600 to-teal-800 text-white font-semibold py-3 px-6 rounded transition" data-aos="fade-up" data-aos-anchor-placement="bottom-bottom">
              Projects in Hand →
            </button>
          </Link>
        </div>
      </div>
    </section>
  );
};



const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Handle submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name || !formData.email || !formData.message) {
      toast.error("Please fill in all fields!");
      return;
    }

    setLoading(true);
    try {
      const res = await fetch("https://pacificbuilders.vercel.app/api/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (res.ok) {
        toast.success("Message sent successfully!");
        setFormData({ name: "", email: "", message: "" });
      } else {
        toast.error("Failed to send message. Try again!");
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Something went wrong. Please try later!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full h-auto bg-white">
      <div className="grid grid-cols-1 lg:grid-cols-2 overflow-hidden">
        {/* Left: Form Side */}
        <div
          className="bg-gradient-to-r from-teal-600 to-teal-800 text-white px-8 py-16"
          data-aos="fade-right"
        >
          <div className="max-w-xl mx-auto">
            <h2 className="text-3xl font-bold text-white mb-2">Contact Us</h2>
            <div className="w-12 border-b-4 border-white mb-8"></div>
            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <input
                  type="text"
                  name="name"
                  placeholder="Name"
                  value={formData.name}
                  onChange={handleChange}
                  className="px-4 py-3 w-full bg-white text-gray-700 placeholder-gray-500 border border-white focus:outline-none"
                />
                <input
                  type="email"
                  name="email"
                  placeholder="Email Address"
                  value={formData.email}
                  onChange={handleChange}
                  className="px-4 py-3 w-full bg-white text-gray-700 placeholder-gray-500 border border-white focus:outline-none"
                />
              </div>
              <textarea
                name="message"
                placeholder="Message"
                rows="6"
                value={formData.message}
                onChange={handleChange}
                className="w-full px-4 py-3 bg-white text-gray-700 placeholder-gray-500 border border-white focus:outline-none"
              />
              <button
                type="submit"
                disabled={loading}
                className="px-6 py-2 border-2 border-white text-white font-semibold tracking-widest hover:bg-white hover:text-[#c07806] transition-all disabled:opacity-60"
              >
                {loading ? "Sending..." : "SEND MESSAGE"}
              </button>
            </form>
          </div>
        </div>

        {/* Right: Contact Info */}
        <div
          className="bg-white flex flex-col justify-between"
          data-aos="fade-left"
        >
          <div className="bg-[#1f1f1f] py-10 px-8 flex justify-center space-x-6 text-white text-xl">
            <a href="#"><FaFacebookF /></a>
            <a href="#"><FaTwitter /></a>
            <a href="#"><FaLinkedinIn /></a>
            <a href="#"><FaInstagram /></a>
          </div>
          <div className="px-8 py-12 text-gray-800 max-w-xl mx-auto space-y-4">
            <div className="flex items-start gap-4">
              <FaMapMarkerAlt className="text-gray-600 mt-1" />
              <p className="text-base font-medium">
                Office 606, Eden Tower, Gulberg, Lahore, Pakistan.
              </p>
            </div>
            <div className="flex items-start gap-4">
              <FaPhoneAlt className="text-gray-600 mt-1" />
              <p className="text-base font-medium">042-35782365</p>
            </div>
            <div className="flex items-start gap-4">
              <FaMobileAlt className="text-gray-600 mt-1" />
              <p className="text-base font-medium">0345-8456449</p>
            </div>
            <div className="flex items-start gap-4">
              <FaEnvelope className="text-gray-600 mt-1" />
              <p className="text-base font-medium">info@pacificbuilders.com</p>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};



// const ContactForm = () => {
//   return (
//     <div className="w-full h-auto bg-white">
//       <div className="grid grid-cols-1 lg:grid-cols-2 overflow-hidden">
//         {/* Left: Form Side */}
//         <div className="bg-gradient-to-r from-teal-600 to-teal-800 text-white px-8 py-16" data-aos="fade-right"> 
//           <div className="max-w-xl mx-auto">
//             <h2 className="text-3xl font-bold text-white mb-2">Contact Us</h2>
//             <div className="w-12 border-b-4 border-white mb-8"></div>
//             <form className="space-y-6">
//               <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                 <input
//                   type="text"
//                   placeholder="Name"
//                   className="px-4 py-3 w-full bg-white text-gray-700 placeholder-gray-500 border border-white focus:outline-none"
//                 />
//                 <input
//                   type="email"
//                   placeholder="Email Address"
//                   className="px-4 py-3 w-full bg-white text-gray-700 placeholder-gray-500 border border-white focus:outline-none"
//                 />
//               </div>
//               <textarea
//                 placeholder="Message"
//                 rows="6"
//                 className="w-full px-4 py-3 bg-white text-gray-700 placeholder-gray-500 border border-white focus:outline-none"
//               />
//               <button
//                 type="submit"
//                 className="px-6 py-2 border-2 border-white text-white font-semibold tracking-widest hover:bg-white hover:text-[#c07806] transition-all"
//               >
//                 SEND MESSAGE
//               </button>
//             </form>
//           </div>
//         </div>

//         {/* Right: Contact Info */}
//         <div className="bg-white flex flex-col justify-between" data-aos="fade-left">
//           <div className="bg-[#1f1f1f] py-10 px-8 flex justify-center space-x-6 text-white text-xl">
//             <a href="#"><FaFacebookF /></a>
//             <a href="#"><FaTwitter /></a>
//             <a href="#"><FaLinkedinIn /></a>
//             <a href="#"><FaInstagram /></a>
//           </div>
//           <div className="px-8 py-12 text-gray-800 max-w-xl mx-auto">
//             <div className="flex items-start gap-4">
//               <FaMapMarkerAlt className="text-gray-600 mt-1" />
//               <p className="text-base font-medium">
//               Office 606, Eden Tower, Gulberg, Lahore, Pakistan.
//               </p>
//             </div>
//             <div className="flex items-start gap-4">
//               <FaPhoneAlt className="text-gray-600 mt-1" />
//               <p className="text-base font-medium">042-35782365</p>
//             </div>
//             <div className="flex items-start gap-4">
//              <p className="flex items-start gap-4">
//                   <FaMobileAlt className="text-gray-600 mt-1" />
//                   <span className="text-base font-medium">
//                      0345-8456449
//                   </span>
//                 </p>
//             </div>

//             <div className="flex items-start gap-4">
//               <FaEnvelope className="text-gray-600 mt-1" />
//               <p className="text-base font-medium">info@pacificbuilders.com</p>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

export default MyPage;
